import React from 'react';
import axios from 'axios';

const InvitationPage = ({history, match}) => {
  const {uuid, language} = match.params;
  axios.post(`${process.env.SERVER_URL}/accept`, {
    uuid
  }).then((res) => {
    if (res && res.data && res.data.need_signup && res.data.email) {
      const email = res.data.email;
      history.push({pathname: '/register', state: {uuid, email, language}});
    } else if (res && res.data && !res.data.need_signup) {
      history.push({pathname: '/accepted', state: {language}});
    } else {
      history.push({pathname: '/404', state: {language}});
    }
  }).catch(() => {
    history.push({pathname: '/404', state: {language}});
  });
  return (
    <div />
  );
};

export default InvitationPage;
